module.exports = __webpack_public_path__ + "img/tablet-button.d19cba.svg";